import { Trans } from '@lingui/react';
import { Checkbox } from '@startuptools/ui/Checkbox';
import { Control, Controller } from 'react-hook-form';

export type FormValues = {
  paymentKindCash: boolean;
  paymentKindOffset: boolean;
  paymentKindNonCash: boolean;
};

export const StepPaymentMethods = ({ control }: { control: Control<FormValues> }) => {
  return (
    <>
      <Controller
        control={control}
        name="paymentKindCash"
        render={({ field: { value, onChange, ...field } }) => (
          <Checkbox checked={value} onChange={a => onChange(a.target.checked)} {...field} label={<Trans id="Cash" />} />
        )}
      />

      <Controller
        control={control}
        name="paymentKindOffset"
        render={({ field: { value, onChange, ...field } }) => (
          <Checkbox
            checked={value}
            onChange={a => onChange(a.target.checked)}
            {...field}
            label={<Trans id="Offset" />}
          />
        )}
      />

      <Controller
        control={control}
        name="paymentKindNonCash"
        render={({ field: { value, onChange, ...field } }) => (
          <Checkbox
            checked={value}
            onChange={a => onChange(a.target.checked)}
            {...field}
            label={<Trans id="In-Kind" />}
          />
        )}
      />
    </>
  );
};
